// extracted by mini-css-extract-plugin
export default {"table":"TimessheetsTable_table__Ysk76"};